import * as yup from 'yup';
const userDataValidation = {
  ChangePasswordSchema: yup.object({
    userEmail: yup
      .string()
      .email('Invalid email')
      .required('Email is required'),
    codeInput: yup.string().required('OTP is required'),
    newPassword: yup.string().required('Password is required'),
    confirmNewPassword: yup
      .string()
      .oneOf([yup.ref('newPassword')], 'Passwords must match')
      .required('Confirm Password is required'),
  }),
};

export default userDataValidation;
